import React from 'react'

import { AcornsIcon } from '@acorns/icons'
import { useRemoteStrings } from '@acorns/web-utils'

import { TestIDs } from 'test/utils/testIds'

import { PreviewPortfolioContainer } from '../styled-components'
import {
  StyledChevron,
  StyledInnerBodytext,
  StyledInnerHeading,
  StyledSustainableLink,
  TitleIconContainer,
} from './styled-components'

type Props = {
  handleSustainableLinkPress: () => void
}

const SustainabilityInfo = (props: Props) => {
  const { getRemoteString } = useRemoteStrings()
  return (
    <PreviewPortfolioContainer>
      <TitleIconContainer>
        <StyledInnerHeading>
          {getRemoteString({
            key: 'portfolio.risk.sustainability.title',
          })}
        </StyledInnerHeading>
        <AcornsIcon
          icon={AcornsIcon.Icon.UtilityLeaf}
          width="24px"
          height="24px"
          style={{ marginTop: '2px' }}
        />
      </TitleIconContainer>
      <StyledInnerBodytext>
        {getRemoteString({
          key: 'portfolio.risk.esg.description',
        })}
      </StyledInnerBodytext>
      <StyledSustainableLink
        onClick={props.handleSustainableLinkPress}
        data-testid={TestIDs.PREVIEW_PORTFOLIO.ABOUT_ESG_LINK}
      >
        {getRemoteString({
          key: 'portfolio.risk.esg.learn_more',
        })}
        <StyledChevron icon={AcornsIcon.Icon.ChevronRightPortfolio} width="12px" height="9px" />
      </StyledSustainableLink>
    </PreviewPortfolioContainer>
  )
}

export default SustainabilityInfo
